import React from 'react';
import { compose } from 'redux';

import { withContent } from 'components/Content';
import DeliveryArea from 'components/DeliveryArea';
import withLanding from 'containers/Landing/withLanding';
import { pages as PAGES } from 'containers/Landing/constants';
import Hero from 'components/Hero';
import Gulch from 'components/Gulch';
import Halfsy from 'components/Halfsy';
import Summary from 'containers/Responsibility/Summary';

import styles from './brandStory.scss';

const CONTENT_KEYS = {
  deliveryArea: 'Delivery Area',
  hero: 'Hero',
  halfsy: 'Halfsies',
  summary: 'Responsibility Summary',
};

const BrandStory = ({ content }) => (
  <div className={styles.brandStory}>
    <Hero content={content.hero} />
    <DeliveryArea content={content.deliveryArea} />
    <Gulch />
    <Summary content={content.summary} />
    <Halfsy content={content.halfsy} />
  </div>
);

export default compose(
  withLanding(PAGES.ourStory),
  withContent(CONTENT_KEYS),
)(BrandStory);
